export default __webpack_public_path__ + "static/media/authorize-icon.b4eb5af0.svg";